import { createAction, props } from '@ngrx/store';
import {
  StaffEventSkeleton,
  PagedStaffEventAudit,
  PagedStaffEventBusinessPersonAudit,
  PagedScheduledEventAudit
} from '../../+models/staff-event-audit.model';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';

export enum StaffEventActionTypes {}

export const ResetStaffEvent = createAction('[SharedAudit StaffEvent] Reset');

export const LoadStaffEventSkeletons = createAction(
  '[SharedAudit StaffEvent] Load StaffEvent Skeletons'
);

export const StaffEventSkeletonsLoaded = createAction(
  '[SharedAudit StaffEvent] StaffEvent Skeletons Loaded',
  props<{ payload: StaffEventSkeleton[] }>()
);

export const StaffEventSkeletonsLoadError = createAction(
  '[SharedAudit StaffEvent] StaffEvent Skeletons Load Error',
  props<{ err: any }>()
);

export const LoadStaffEventAudit = createAction(
  '[SharedAudit StaffEvent] Load StaffEvent Audit',
  props<{ staffEventId: number }>()
);

export const LoadNextPageStaffEventAudit = createAction(
  '[SharedAudit StaffEvent] Load NextPage StaffEvent Audit',
  props<{ staffEventId: number }>()
);

export const StaffEventAuditLoaded = createAction(
  '[SharedAudit StaffEvent] StaffEvent Audit Loaded',
  props<{ staffEventId: number; audits: PagedStaffEventAudit }>()
);

export const StaffEventAuditLoadError = createAction(
  '[SharedAudit StaffEvent] StaffEvent Audit Load Error',
  props<{ err: any }>()
);

export const LoadStaffEventBusinessPersonAudit = createAction(
  '[SharedAudit StaffEvent] Load StaffEventBusinessPerson Audit',
  props<{ staffEventBusinessPersonId: number }>()
);

export const LoadNextPageStaffEventBusinessPersonAudit = createAction(
  '[SharedAudit StaffEvent] Load NextPage StaffEventBusinessPerson Audit',
  props<{ staffEventBusinessPersonId: number }>()
);

export const StaffEventBusinessPersonAuditLoaded = createAction(
  '[SharedAudit StaffEvent] StaffEventBusinessPerson Audit Loaded',
  props<{
    staffEventBusinessPersonId: number;
    audits: PagedStaffEventBusinessPersonAudit;
  }>()
);

export const StaffEventBusinessPersonAuditLoadError = createAction(
  '[SharedAudit StaffEvent] StaffEventBusinessPerson Audit Load Error',
  props<{ err: any }>()
);

export const LoadScheduledEventAudit = createAction(
  '[SharedAudit StaffEvent] Load ScheduledEvent Audit',
  props<{ scheduledEventId: number }>()
);

export const LoadNextPageScheduledEventAudit = createAction(
  '[SharedAudit StaffEvent] Load NextPage ScheduledEvent Audit',
  props<{ scheduledEventId: number }>()
);

export const ScheduledEventAuditLoaded = createAction(
  '[SharedAudit StaffEvent] ScheduledEvent Audit Loaded',
  props<{ scheduledEventId: number; audits: PagedScheduledEventAudit }>()
);

export const ScheduledEventAuditLoadError = createAction(
  '[SharedAudit StaffEvent] ScheduledEvent Audit Load Error',
  props<{ err: any }>()
);

export const LoadStaffEventTypes = createAction('[SharedAudit StaffEvent] Load StaffEvent Type');

export const StaffEventTypesLoaded = createAction(
  '[SharedAudit StaffEvent] StaffEvent Type Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const StaffEventTypesLoadError = createAction(
  '[SharedAudit StaffEvent] StaffEvent Type Load Error',
  props<{ err: any }>()
);
